<script>
import BoggleTile from "./BoggleTile.svelte";
import { boggleWords } from "../store/words";
import { onDestroy, onMount } from "svelte";
import { words, score, gameDice, pauseBoggleGame, seconds, setupBoogleGame, saveBoggleGame } from "../store/boggle";

let countdown = 0
let selectedTiles = []
let usedLocations = []
let interval
const isWord = (word) => {
  return $boggleWords.findIndex(w => w === word) !== -1
}
const dailyBoggle = 'S,Y,T,G,N,F,L,O,L,U,A,K,E,P,F,M'

const neighbors = {
  0: [1,4,5],
  1: [0,2,4,5,6],
  2: [1,3,5,6,7],
  3: [2,6,7],
  4: [0,1,5,8,9],
  5: [0,1,2,4,6,8,9,10],
  6: [1,2,3,5,7,9,10,11],
  7: [2,3,6,10,11],
  8: [4,5,9,12,13],
  9: [4,5,6,8,10,12,13,14],
  10: [5,6,7,9,11,13,14,15],
  11: [6,7,10,14,15],
  12: [8,9,13],
  13: [8,9,10,12,14],
  14: [9,10,11,13,15],
  15: [10,11,14],
}
const standardDice = [
  {die: ['R','I','F','O','B','X'], color: 'silver'},
  {die: ['I','F','E','H','E','Y'], color: 'red'},
  {die: ['D','E','N','O','W','S'], color: 'Black'},
  {die: ['U','T','O','K','N','D'], color: 'Maroon'},
  {die: ['H','M','S','R','A','O'], color: 'Yellow'},
  {die: ['L','U','P','E','T','S'], color: 'Olive'},
  {die: ['A','C','I','T','O','A'], color: 'Lime'},
  {die: ['Y','L','G','K','U','E'], color: 'Agua'},
  {die: ['Qu','B','M','J','O','A'], color: 'Teal'},
  {die: ['E','H','I','S','P','N'], color: 'Blue'},
  {die: ['V','E','T','I','G','N'], color: 'Navy'},
  {die: ['B','A','L','I','Y','T'], color: 'Fuchsia'},
  {die: ['E','Z','A','V','N','D'], color: 'Purple'},
  {die: ['R','A','L','E','S','C'], color: 'White'},
  {die: ['U','W','I','L','R','G'], color: 'Gray'},
  {die: ['P','A','C','E','M','D'], color: 'Pink'},
]
$gameDice = standardDice.map(die => die[0])

const selectTile = (ev) => {
  console.log(ev.detail)
  if (selectedTiles.length) {
    // remove
    if (selectedTiles[selectedTiles.length - 1]?.location === ev.detail.location) {
      usedLocations = usedLocations.filter(l => l !== ev.detail.location)
      selectedTiles = selectedTiles.filter((t,idx) => idx !== selectedTiles.length - 1)
    // add
    } else if(neighbors[selectedTiles[selectedTiles.length - 1]?.location]?.includes(ev.detail.location) && !usedLocations.includes(ev.detail.location)) {
      usedLocations = [...usedLocations, ev.detail.location]
      selectedTiles = [...selectedTiles, ev.detail]
    // first tile
    }
  } else {
    usedLocations = [...usedLocations, ev.detail.location]
    selectedTiles = [...selectedTiles, ev.detail]
  }
  
}
const saveWord = () => {
  const word = selectedTiles.map(t => t.letter).join('').toLowerCase()
  console.log(word, isWord(word), $words.includes(word))
  if (isWord(word) && !$words.includes(word)) {
    $words = [...$words, word]
    if (word.length > 2 && word.length < 5)
      $score += 1
    else if (word.length === 5)
      $score += 2
    else if (word.length === 6)
      $score += 3
    else if (word.length === 7)
      $score += 5
    else if (word.length > 7)
      $score += 11
  }
  saveBoggleGame()
  selectedTiles = []
  usedLocations = []
}

const clearWord = () => {
  selectedTiles = []
  usedLocations = []
}

const shakem = async () => {
  //handle the timer
  countdown = 5
  selectedTiles = []
  $words = []
  interval = setInterval(() => {
    countdown--
  }, 1000)

  for (let i = 0; i < 24; i++) {
    const copy = [...standardDice]
    const dice = []
    for (let index = 0; index < standardDice.length; index++) {
      const rndDice = Math.floor(Math.random() * (15 - index))
      const rndFace = Math.floor(Math.random() * 6)
      dice.push(copy[rndDice].die[rndFace])
      copy.splice(rndDice, 1)
    }
    $gameDice = dice
    await new Promise(resolve => setTimeout(resolve, 200))
  }
  setupBoogleGame(dailyBoggle, hash)
}
shakem()
onMount(() => {
  // shakem()
  // window.addEventListener('keydown', handleKeyDown)
})
onDestroy(() => {
  pauseBoggleGame()
  // window.removeEventListener('keydown', handleKeyDown)
})
$: hash = location.hash ? location.hash.split('#')[1] : ''
$: {
  if(countdown === 0) {
    clearInterval(interval)
  }
  if (hash) {
    const lettersWithSalt = window.atob(hash)
    const gameLetters = lettersWithSalt.split('+')[0]
    $gameDice = gameLetters.split(',')
  }
}
</script>

<div class="flex flex-col max-w-md mx-auto h-full p-4">
  <div class="relative w-full grid grid-cols-4 max-w-[350px] mx-auto gap-2">
    {#if countdown > 0}
      <div class="absolute z-10 inset-0 flex items-center justify-center" style="background: rgba(0,0,0,0.3)">
        <div class="relative z-50 flex items-center justify-center text-white text-[12rem]">{ countdown }</div>
      </div>
    {/if}
    {#each $gameDice as die, i}
      <BoggleTile letter={die} location={i} on:selectTile={selectTile} selected={selectedTiles} />
    {/each}
  </div>
  <div class="flex items-center justify-center text-lg p-2">
    {#each selectedTiles as { letter } }
      <div>{ letter }</div>
    {/each}
  </div>
  {#if selectedTiles.length && $seconds > 0}
    <div class="flex space-x-2 justify-center items-center my-4">
      <button class="py-2 px-4 bg-teal-700 text-white rounded-md" on:click={clearWord}>Clear</button>
      <button class="py-2 px-4 bg-teal-700 text-white rounded-md" on:click={saveWord}>Save</button>
    </div>
  {/if}
  <div>Score: {$score}</div>
  <!-- <div>
    {#each wordList as word }
      <div>{ word }</div>
    {/each}
  </div> -->
  <!-- <div class="my-4">
    <button class="py-2 px-4 bg-teal-700 text-white rounded-md" on:click={shakem}>Shake it up</button>
  </div> -->
  
</div>
